import React, { Profiler } from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {signOut} from '../../store/actions/authActions'
import {resetSearch} from '../../store/actions/machineActions'
import {resetAllMachines} from '../../store/actions/machineActions'

import {
    NavLink,
  } from 'reactstrap';

const SignedInLinks = (props) => {
    return(
    <>
      {/* <NavLink tag={Link} to="/addmachine">Add Machine</NavLink> */}
      <NavLink tag={Link} to="/">{props.profile.name}</NavLink>
      {/* <NavLink tag={Link} to="/signup">Add New User</NavLink> */}
      <NavLink tag={Link} to="/" onClick={props.logout}>Log Out</NavLink>
    </>
    )
}


const mapDispatchToProps = (dispatch) =>({
  logout : ()=> {
    dispatch(resetSearch());
    dispatch(resetAllMachines());
    dispatch(signOut());
  }
});



export default connect(null,mapDispatchToProps)(SignedInLinks);